import React from 'react';

/**
 * The "{ } Dynamic" pill shown inline at the right edge of a field label when the
 * field holds a dynamic merge-tag value (e.g. a brand colour). Plain markup + Bay
 * design tokens — no Arco dependency, so it can sit in any label row.
 */
export function DynamicLabelPill() {
	return (
		<span
			style={{
				display: 'inline-flex',
				alignItems: 'center',
				gap: '0.25rem',
				padding: '0.1875rem 0.5rem',
				borderRadius: '9999px',
				backgroundColor: 'var(--bs-blue-50, #e7f0ff)',
				color: 'var(--bs-primary, #1571f0)',
				fontSize: '0.6875rem',
				fontWeight: 600,
				lineHeight: 1,
				whiteSpace: 'nowrap',
			}}
		>
			<span
				style={{
					fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
					fontWeight: 700,
				}}
			>
				{'{ }'}
			</span>
			Dynamic
		</span>
	);
}
